<div class="login-container">
  <div class="login-card">
    <div class="login-header">
      <h1>LaBase Admin</h1>
      <p>Connectez-vous pour accéder à l'administration</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="votre@email.com"
          [class.error]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
        />
        @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
          <div class="error-message">
            @if (loginForm.get('email')?.errors?.['required']) {
              <span>L'email est requis</span>
            }
            @if (loginForm.get('email')?.errors?.['email']) {
              <span>Email invalide</span>
            }
          </div>
        }
      </div>

      <div class="form-group">
        <label for="password">Mot de passe</label>
        <input
          id="password"
          type="password"
          formControlName="password"
          placeholder="Votre mot de passe"
          [class.error]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
        />
        @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
          <div class="error-message">
            @if (loginForm.get('password')?.errors?.['required']) {
              <span>Le mot de passe est requis</span>
            }
            @if (loginForm.get('password')?.errors?.['minlength']) {
              <span>Le mot de passe doit contenir au moins 6 caractères</span>
            }
          </div>
        }
      </div>

      @if (errorMessage) {
        <div class="error-message">
          {{ errorMessage }}
        </div>
      }

      <button type="submit" class="btn-login" [disabled]="loginForm.invalid || isLoading">
        @if (!isLoading) {
          <span>Se connecter</span>
        }
        @if (isLoading) {
          <span>Connexion...</span>
        }
      </button>
    </form>
  </div>
</div>
